<!-- eslint-disable no-console -->
<template>
    <div>       
        <v-btn flat @click="getExpectedTransactions" color="primary">Refresh</v-btn>
        <v-btn flat @click="addExpectedTransactions" color="primary">Add upcoming transaction</v-btn>
       <gat-grid title="Upcoming transactions" :items="expectedTransactions" :columns="columns" @row-clicked="editTransaction">        
       </gat-grid>       
    </div>
 </template>
 
 <script lang="ts">
 import Vue from "vue";
import GatGrid from "../../../GatComponents/GatGrid.vue";

 
 
 export default Vue.extend({
    name: "ExpectedTransactionsView",
    components: {GatGrid },    
    data() {
       return {          
       };
    },
 
    activated() {},
 
    mounted() {
        if(this.$store.state.expectedTransactions.length == 0){
            this.$store.dispatch("getExpectedTransactions");
        }
       //this.getExpectedTransactions();
    },
 
    deactivated() {},
 
    computed: {
        expectedTransactions(){
            return this.$store.state.expectedTransactions;
        },
        
         columns() {
             return [
                 { field: "TRANSACTION_DATE", header: "Date", dataType: "date" },
                 { field: "SUPPLIER", header: "Supplier" },                 
                 { field: "AMOUNT", header: "Amount", dataType: "number", decimals:2,numberFormat:"0,0.00" },
                 { field: "DESCRIPTION", header: "Description" },
                 { field: "CATEGORY_ID", header: "Category", calculated: (item) => this.getCategoryName(item.CATEGORY_ID)}                 
             ];
         },
      
    },
 
    methods: {

        addExpectedTransactions() {
            this.$router.push({ name: "AddExpectedTransaction" });
        },
        editTransaction(transaction){
            this.$router.push({ name: "editExpectedTransaction", params: { id: transaction.ID } });
        },
        getExpectedTransactions() {
            this.$store.dispatch("getExpectedTransactions");
        },                
 
       getCategoryName(catId){
        let result = this.$store.state.categories.find(item=>{
                    return item.CAT_ID == catId;
                })
                if(result){
                    return result.fullName;
                } else{
                    return null;
                }               
       }
      
     
      
    },
 });
 </script>
 
 <style scoped>
 
 </style>
 